import React from 'react';
import {
    FacebookShareButton,
    TwitterShareButton,
    WhatsappShareButton,
} from 'react-share';
import PropTypes from 'prop-types';
import useSiteMetadata from '@hooks/useSiteMetadata';
import FacebookIcon from '@components/Icons/facebook.svg';
import WhatsAppIcon from '@components/Icons/whatsApp.svg';
import TwitterIcon from '@components/Icons/twitter.svg';
import styles from './share-icons.module.scss';

const ShareIcons = ({ locationPath, title }) => {
    const { siteURL, author } = useSiteMetadata();
    const currentURL = `${siteURL}${locationPath.pathname}`;

    return (
        <ul className={styles.shareList}>
            <li className={styles.shareListItem}>
                <FacebookShareButton
                    className={styles.iconButton}
                    url={currentURL}
                >
                    <FacebookIcon />
                </FacebookShareButton>
            </li>

            <li className={styles.shareListItem}>
                <TwitterShareButton
                    className={styles.iconButton}
                    url={currentURL}
                    title={title}
                    via={author.replace(/@/, '')}
                >
                    <TwitterIcon />
                </TwitterShareButton>
            </li>

            <li className={styles.shareListItem}>
                <WhatsappShareButton
                    className={styles.iconButton}
                    url={currentURL}
                    title={title}
                >
                    <WhatsAppIcon />
                </WhatsappShareButton>
            </li>
        </ul>
    );
};

ShareIcons.propTypes = {
    locationPath: PropTypes.shape({
        pathname: PropTypes.string,
    }).isRequired,
    title: PropTypes.string,
};

ShareIcons.defaultProps = {
    title: null,
};

export default ShareIcons;
